export const DEFAULT_VALUES = {
  title:
    "Moody's - credit ratings, research, and data for global capital markets",
  meta: [
    {
      name: "description",
      content:
        "Moody's CreditView is our flagship solution for global capital markets that incorporates credit ratings, research and data from Moody's Investors Service plus research, data and content from Moody's Analytics.",
    },
  ],
};
